import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const mediaKitRoutes = [
  /**
   * Examples:
   * https://www.edmunds.com/media-kit/
   * https://www.edmunds.com/media-kit/ad-specs.html
   * https://www.edmunds.com/media-kit/ad-specs/homepage-leaderboard.html
   * https://www.edmunds.com/media-kit/ad-specs/native/native-incentives-offer.html
   */
  {
    path: ['/media-kit', '/media-kit/:splat*/:articleId.html'],
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "media-kit-article" */ '../pages/media-kit/media-kit-definition'),
      ({ params }) => params
    ),
    chunkName: 'media-kit-article',
  },
];
